<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12">
                <h2 class="order-summary__head">
                    {{ getTranslation('licence-configurator', 'product_name_upgrade_to_perpetual', {'name': product.name }) }}
                </h2>
            </div>
        </div>

        <div class="custom-table">
            <div class="row custom-table__head d-none d-sm-flex">
                <div class="col-6"><div class="custom-table__head--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'quantity') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'price') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'total') }}</div></div>
            </div>
            <div class="row no-gutters custom-table__body">
                <template v-for="program in sortedPrograms()">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem">{{ programName(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ linePrice(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ priceFormat(getProgramPrice(program.id, '', licenceType, program.product, program[licenceType] * 3), true) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
            </div>
        </div>
        <br><br>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedPrograms() {
                return  _.sortBy(this.programs, [function(o) { return o.sortOrder; }]).reverse();
            },
            quantity(program) {
                return _.isNil(program[this.licenceType]) ? 0 : program[this.licenceType]
            },
            linePrice(program) {
                return this.priceFormat(this.getProgramPrice(program.id, '', this.licenceType, program.product, 3), true)
            },
            programName(program) {
                return program.name;
            }
        },
        beforeMount() {
            this.programs = _.filter(this.programs, {product: this.product.id, perpetual_upgrade: true});
        },
        computed: {

        },
        data() {
            return {
                products: window.jsonProducts,
                programs: this.$store.state.cart.programs,
                licenceType: this.getQtyName('lease', 'cloud')
            };
        },
        props: {
            product: Object
        }
    }
</script>
